import CloudSyncOutlinedIcon from "@mui/icons-material/CloudSyncOutlined";
import { useTheme } from "@mui/material/styles";

const ResendConfigIconButton = ({
  onClick,
}: {
  onClick?: () => void;
}): JSX.Element => {
  const theme = useTheme();

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      style={{ cursor: "pointer" }}
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <rect
        x="0.5"
        y="0.5"
        width="31"
        height="31"
        rx="7.5"
        fill={theme.palette.otherBackgroundLight.main}
      />
      <foreignObject x="4" y="4" width="24" height="24">
        <CloudSyncOutlinedIcon
          sx={{
            color: theme.palette.primary.main,
            fontSize: 24,
          }}
        />
      </foreignObject>
      <rect
        x="0.5"
        y="0.5"
        width="31"
        height="31"
        rx="7.5"
        stroke={theme.palette.otherOutlineBorder.main}
      />
    </svg>
  );
};

export default ResendConfigIconButton;
